import { Button } from "@mui/material";
import React from "react";
import MDialog, { EMDialogType } from "./MDialog";

const ImportErrorDialog: React.FC<{
  title: string;
  open: boolean;
  handleReImport(): void;
}> = (props) => {
  const { title, open, handleReImport, children } = props;
  return (
    <MDialog
      title={title}
      type={EMDialogType.ERROR}
      open={open}
      maxWidth={"sm"}
      fullWidth
      renderMoreButton={
        <Button variant="contained" onClick={handleReImport}>
          Nhập lại
        </Button>
      }
    >
      {children}
    </MDialog>
  );
};

export default ImportErrorDialog;
